export default function () {
    const forms = document.querySelectorAll('[data-xhr-form]');
    // Loop through each XHR Form and initialize it
    for (let i = 0; i < forms.length; i++) {
        const form = forms[i];
        const formSelectorsAttribute = form.getAttribute('data-xhr-form');
        const formSelectors = JSON.parse(formSelectorsAttribute);

        // get the form selectors from it's data-xhr-form element...
        const formSelector = form.querySelector(formSelectors.formSelector);
        const formAction = formSelector.getAttribute('action');
        const formMethod = formSelector.getAttribute('method');
        const requestVerificationToken = form.querySelector('input[name="__RequestVerificationToken"]');
        const errorIcon = `<svg class="svg svg--alert--red svg--alert--red--lg"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#alert-red"></use></svg>`;

        const sendData = () => {
            const XHR = new XMLHttpRequest();
            // Bind the FormData object and the form element
            // https://developer.mozilla.org/en-US/docs/Learn/Forms/Sending_forms_through_JavaScript#using_xmlhttprequest_and_the_formdata_object
            const formData = new FormData(formSelector);
            console.log(...formData)

            XHR.onreadystatechange = function () {
                console.log('onreadystatechange');
                if (XHR.readyState === XMLHttpRequest.DONE) {
                    if (this.readyState == 4 && this.status == 200) {
                        const response = JSON.parse(this.responseText);
                        console.log('response: ', response);
                        const responseStatus = response.Success ? 'success' : 'error';
                        const renderErrorIcon = responseStatus === 'error' ? errorIcon : ``;

                        const responseTemplate = `
                            <div class="u-textCenter">
                                <div class="Form-response Form-response--${responseStatus}">
                                    ${renderErrorIcon}
                                    <div>${response.Message}</div>
                                </div>
                            </div>
                        `;
                        formSelector.insertAdjacentHTML('afterend', responseTemplate);
                    } else {
                        // In case the XHR failed, so show generic error message
                        const responseTemplate = `
                            <div class="u-textCenter">
                                <div class="Form-response Form-response--error">
                                    ${errorIcon}
                                    <div>Please try again later.</div>
                                </div>
                            </div>
                        `;
                        formSelector.insertAdjacentHTML('afterend', responseTemplate);
                    }
                    formSelector.scrollIntoView();
                }
            };

            // Set up our request
            XHR.open(formMethod, formAction);
            if (requestVerificationToken !== null) {
                XHR.setRequestHeader('__RequestVerificationToken', requestVerificationToken.value);
            }
            // The data sent is what the user provided in the form
            XHR.send(formData);
        };
        formSelector.addEventListener('submit', (e) => {
            e.preventDefault();
            
            // Check form validation, if there are any errors, then do not send the form data.
            if (!formSelector.checkValidity()) return;
            // If form validation passes, then post data
            sendData(e);
        });
    }
}

